import {Address} from "@irati/types"
import {createContext} from "react"

interface AddressFormContextTypes {
  shippingAddress: Address
  onFieldChange: (newAddress: Address) => void
}

const CONTEXT_DEFAULT_VALUES = {
  shippingAddress: {},
  onFieldChange: () => {}
}

const AddressFormContext = createContext<AddressFormContextTypes>(CONTEXT_DEFAULT_VALUES)

export default AddressFormContext
